import React from 'react';
import { NavLink, useParams } from 'react-router-dom';
import { getEntryLink } from './Bulletin.helper';

import './VariableListItem.scss';
import { BulletinEntry } from './types';

interface VariableListItemProps {
  entry: BulletinEntry;
  userIsAuthenticated: boolean;
}

const VariableListItem = ({
  entry,
  userIsAuthenticated,
}: VariableListItemProps) => {
  const { bulletinDate, bulletinType } = useParams();
  return (
    <li className={`entries-item ${entry.outdated ? 'outdated' : ''}`}>
      <NavLink
        className={({ isActive }) => (isActive ? 'active' : '')}
        to={getEntryLink(bulletinType, bulletinDate, entry) ?? ''}
      >
        {entry.name}
      </NavLink>
      {entry.outdated === true && (
        <span className="icon icon-outdated" data-cy="variable-is-outdated" />
      )}
      {userIsAuthenticated && entry.unseen && (
        <span className="icon icon-eye-close" data-cy="variable-is-unseen" />
      )}
      {userIsAuthenticated && entry.flag && (
        <span className="icon icon-flag" data-cy="variable-is-flagged" />
      )}
    </li>
  );
};

export default VariableListItem;
